import { HTTP } from '..'

const END_POINT = 'api/bonita/getDatosQR?id_folio='

const apiGetDatosAlumnoQR = (folio) => {
  return new Promise((resolve, reject) => {
    HTTP.get(END_POINT + folio)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { apiGetDatosAlumnoQR }